<template>
  <div class="upload-container">
    <el-tooltip class="item" effect="dark" content="插入附件" placement="bottom">
      <el-button type="info"  icon="el-icon-upload" @click=" dialogVisible=true" circle></el-button>
    </el-tooltip>

    <el-dialog append-to-body :visible.sync="dialogVisible">
      <el-upload class="editor-slide-upload"
                 action="http://gongyiguanliapi.gongyishibao.com/upfile/upload"
                 :data="dataObj"
                 :multiple="true"
                 :file-list="fileList"
                 :show-file-list="true"
                 :on-remove="handleRemove"
                 :on-success="handleSuccess"
                 :before-upload="beforeUpload">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>

  export default {
    name: 'editorSlideUpload',
    props: {
      color: {
        type: String,
        default: '#1890ff'
      }
    },
    data() {
      return {
        dialogVisible: false,
        listObj: {},
        fileList: [],
        dataObj: {
          policy: '',
          signature: '',
          key: '',
          ossaccessKeyId: '',
          dir: '',
          host: ''
        }
      }
    },
    methods: {
      handleSubmit() {
        const arr = Object.keys(this.listObj).map(v => this.listObj[v])
        console.log(this.dataObj);
        console.log(this.listObj);
        console.log(this.fileList);
        this.$emit('successCBK', arr);
        this.listObj = {};
        this.fileList = [];
        this.dialogVisible = false;
      },
      handleSuccess(response, file) {
        const uid = file.uid;
        const objKeyArr = Object.keys(this.listObj)
        console.log(response)

        for (let i = 0, len = objKeyArr.length; i < len; i++) {
          if (this.listObj[objKeyArr[i]].uid === uid) {
            this.listObj[objKeyArr[i]].url = response.data.url;
            this.listObj[objKeyArr[i]].name = response.data.name;
            this.listObj[objKeyArr[i]].hasSuccess = true;
            console.log(this.listObj[objKeyArr[i]])
            return
          }
        }
      },
      handleRemove(file) {
        const uid = file.uid;
        const objKeyArr = Object.keys(this.listObj);
        for (let i = 0, len = objKeyArr.length; i < len; i++) {
          if (this.listObj[objKeyArr[i]].uid === uid) {
            delete this.listObj[objKeyArr[i]];
            return
          }
        }
      },
      beforeUpload(file) {
        const _self = this
        const fileName = file.uid;
        this.listObj[fileName] = {};
        return new Promise((resolve, reject) => {

          _self.dataObj.policy = '';
          _self.dataObj.signature = '';
          _self.dataObj.ossaccessKeyId = '';
          _self.dataObj.key = '/${filename}';
          _self.dataObj.dir = '';
          _self.dataObj.host = '';
          _self.listObj[fileName] = {hasSuccess: false, uid: file.uid, width: this.width, height: this.height};
          resolve(true)

        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .editor-slide-upload{
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tinymce/components/editorFile.vue